module.exports = __webpack_public_path__ + "media/images/top/sp-slide-next-3a13e85ff6ad75077aa451470b660c8d.svg";